// extracted by mini-css-extract-plugin
export default {"emptySquare":"CheckBoxInput_emptySquare__zwCSl","checked":"CheckBoxInput_checked__i20sm"};